import { render, staticRenderFns } from "./choseCustomColor.vue?vue&type=template&id=431747c6"
import script from "./choseCustomColor.vue?vue&type=script&lang=js"
export * from "./choseCustomColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports